module.exports = __webpack_public_path__ + "img/01-welcome.5fb0b252.png";